<template>
  <div>
    <!-- Navbar -->
    <b-navbar toggleable="lg" type="dark" variant="primary" fixed="top">
      <b-navbar-brand href="#" @click="$router.back()">
        <b-icon icon="arrow-left"></b-icon> {{ $route.query.desc || 'ໂຮງຮຽນ' }}
      </b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <b-nav-item>
          <b-button size="sm" variant="light" @click="openImport">
            <b-icon icon="file-earmark-excel-fill" class="mr-1" style="color:#217346"></b-icon>
            ນຳເຂົ້າຈາກ Excel
          </b-button>
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>

    <!-- Content -->
    <b-row class="h-100" style="margin-top:70px; padding: 16px;">
      <!-- Tree View -->
      <b-col md="5">
        <b-card header="ລາຍຊື່ໂຮງຮຽນ">
          <div style="height:600px; overflow:auto;">
            <b-tree-view
              :data="treeData"
              :contextMenu="false"
              @nodeSelect="nodeSelect"
            ></b-tree-view>
          </div>
        </b-card>
      </b-col>

      <!-- Detail panel -->
      <b-col>
        <b-card header="ຂໍ້ມູນໂຮງຮຽນ">
          <div v-if="selectedNode && selectedNode.visable == 1">
            <b-list-group flush>
              <b-list-group-item class="d-flex justify-content-between">
                <span class="text-muted">ລະຫັດໂຮງຮຽນ</span>
                <strong>{{ selectedNode.id }}</strong>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between">
                <span class="text-muted">EMIS CODE</span>
                <strong>{{ selectedNode.emis_code }}</strong>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between">
                <span class="text-muted">ຊື່ໂຮງຮຽນ</span>
                <strong>{{ selectedNode.name }}</strong>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between">
                <span class="text-muted">ລະຫັດເມືອງ</span>
                <strong>{{ selectedNode.district_id }}</strong>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between">
                <span class="text-muted">ຊື່ເມືອງ</span>
                <strong>{{ selectedNode.d_name }}</strong>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between">
                <span class="text-muted">ລະຫັດແຂວງ</span>
                <strong>{{ selectedNode.prov_id }}</strong>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between">
                <span class="text-muted">ຊື່ແຂວງ</span>
                <strong>{{ selectedNode.p_name }}</strong>
              </b-list-group-item>
            </b-list-group>
          </div>
          <div v-else class="text-center text-muted py-5">
            <b-icon icon="info-circle" font-scale="2" class="mb-2"></b-icon>
            <p>ກະລຸນາເລືອກໂຮງຮຽນຈາກລາຍຊື່ດ້ານຊ້າຍ</p>
          </div>
        </b-card>

        <!-- ຂໍ້ມູນນັກຮຽນປະຈຳສົກຮຽນ -->
        <b-card header="ຂໍ້ມູນນັກຮຽນປະຈຳສົກຮຽນ" class="mt-3" v-if="selectedNode && selectedNode.visable == 1">
          <b-form-group label="ສົກຮຽນ" label-class="label-style">
            <b-form-select
              v-model="statsAccd"
              :options="[{value:'',text:'ເລືອກສົກຮຽນ'},...accdOptions]"
              @change="loadYearlyStats"
            ></b-form-select>
          </b-form-group>

          <b-row v-if="statsAccd">
            <b-col md="4">
              <b-form-group label="ຈຳນວນນັກຮຽນລວມ" label-class="label-style">
                <b-form-input v-model="stats.total_students" type="number" min="0"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="ຍິງ" label-class="label-style">
                <b-form-input v-model="stats.female_students" type="number" min="0"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="ຊາຍ" label-class="label-style">
                <b-form-input v-model="stats.male_students" type="number" min="0"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <hr />
              <span class="text-muted d-block mb-2">ຈຳນວນນັກຮຽນທີ່ໄດ້ຮັບອາຫານທ່ຽງຕົວຈິງ</span>
            </b-col>
            <b-col md="4">
              <b-form-group label="ລວມ" label-class="label-style">
                <b-form-input v-model="stats.lunch_total" type="number" min="0"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="ຍິງ" label-class="label-style">
                <b-form-input v-model="stats.lunch_female" type="number" min="0"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="ຊາຍ" label-class="label-style">
                <b-form-input v-model="stats.lunch_male" type="number" min="0"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="text-right" v-if="statsAccd">
            <b-button variant="outline-primary" class="mr-2" @click="addNextAccd">
              <b-icon icon="plus-circle" class="mr-1"></b-icon>
              ເພີ່ມສົກຮຽນຕໍ່ໄປ
            </b-button>
            <b-button variant="success" :disabled="statsSaving" @click="saveYearlyStats">
              <b-spinner small v-if="statsSaving" class="mr-1"></b-spinner>
              <b-icon icon="save" class="mr-1" v-else></b-icon>
              ບັນທຶກ
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Import Modal -->
    <b-modal
      ref="import-modal"
      size="xl"
      title="ນຳເຂົ້າຂໍ້ມູນໂຮງຮຽນຈາກ Excel"
      header-bg-variant="success"
      header-text-variant="white"
      hide-footer
      @hidden="resetImport"
    >
      <!-- Step 1: File select -->
      <div v-if="importStep === 1" class="p-2">
        <b-alert show variant="info" class="mb-3">
          <b-icon icon="info-circle-fill" class="mr-2"></b-icon>
          ໄຟລ໌ Excel ຕ້ອງມີຖັນ:
          <strong>school_id</strong>, <strong>school_name_lao</strong>, <strong>district_id</strong>
          (ແລະ ທາງເລືອກ: school_name_eng, emis_code, prov_id, School_lunch)
        </b-alert>

        <b-form-group label="ເລືອກໄຟລ໌ Excel (.xlsx / .xls)">
          <b-form-file
            v-model="excelFile"
            accept=".xlsx,.xls"
            placeholder="ລາກໄຟລ໌ມາວາງ ຫຼື ກົດເພື່ອເລືອກ..."
            drop-placeholder="ລາກໄຟລ໌ມາວາງໃສ່ນີ້..."
            @change="onFileChange"
          ></b-form-file>
        </b-form-group>

        <div v-if="fileLoading" class="text-center py-4">
          <b-spinner variant="success" class="mb-2"></b-spinner>
          <p class="text-muted">ກຳລັງອ່ານໄຟລ໌ ແລະ ກວດສອບລະຫັດໂຮງຮຽນ...</p>
        </div>

        <!-- Download template link -->
        <div class="mt-3">
          <b-button variant="outline-secondary" size="sm" @click="downloadTemplate">
            <b-icon icon="download" class="mr-1"></b-icon> ດາວໂຫຼດ Template Excel
          </b-button>
        </div>
      </div>

      <!-- Step 2: Preview + validate -->
      <div v-if="importStep === 2" class="p-2">
        <!-- Summary badges -->
        <div class="d-flex align-items-center mb-3 flex-wrap" style="gap:8px">
          <b-badge variant="secondary" pill class="px-3 py-2 font-size-sm">
            ທັງໝົດ {{ importRows.length }} ລາຍການ
          </b-badge>
          <b-badge variant="success" pill class="px-3 py-2">
            <b-icon icon="check-circle-fill" class="mr-1"></b-icon>
            ໃໝ່: {{ newCount }}
          </b-badge>
          <b-badge variant="warning" pill class="px-3 py-2">
            <b-icon icon="exclamation-triangle-fill" class="mr-1"></b-icon>
            ມີຢູ່ແລ້ວ: {{ dupCount }}
          </b-badge>
          <b-badge variant="danger" pill class="px-3 py-2" v-if="errorCount > 0">
            <b-icon icon="x-circle-fill" class="mr-1"></b-icon>
            ຂໍ້ມູນບໍ່ຄົບ: {{ errorCount }}
          </b-badge>
        </div>

        <!-- Preview table -->
        <div style="max-height:420px; overflow-y:auto;">
          <b-table
            :items="importRows"
            :fields="previewFields"
            small
            bordered
            striped
            responsive
            class="mb-0"
          >
            <template #cell(_status)="data">
              <b-badge
                :variant="statusVariant(data.item._status)"
                class="px-2"
              >
                <b-icon :icon="statusIcon(data.item._status)" class="mr-1"></b-icon>
                {{ statusLabel(data.item._status) }}
              </b-badge>
            </template>
          </b-table>
        </div>

        <!-- Action buttons -->
        <div class="d-flex justify-content-between mt-3">
          <b-button variant="outline-secondary" @click="importStep = 1; excelFile = null">
            <b-icon icon="arrow-left" class="mr-1"></b-icon> ກັບຄືນ
          </b-button>
          <div>
            <span class="text-muted mr-3 small" v-if="newCount === 0">ບໍ່ມີລາຍການໃໝ່ທີ່ຈະນຳເຂົ້າ</span>
            <b-button
              variant="success"
              :disabled="newCount === 0 || importing"
              @click="doImport"
            >
              <b-spinner small v-if="importing" class="mr-1"></b-spinner>
              <b-icon icon="cloud-upload-fill" class="mr-1" v-else></b-icon>
              ນຳເຂົ້າ {{ newCount }} ລາຍການໃໝ່
            </b-button>
          </div>
        </div>
      </div>

      <!-- Step 3: Result -->
      <div v-if="importStep === 3" class="p-3 text-center">
        <b-icon icon="check-circle-fill" variant="success" font-scale="4" class="mb-3"></b-icon>
        <h5 class="text-success">ນຳເຂົ້າສຳເລັດ!</h5>
        <p class="text-muted">ນຳເຂົ້າ {{ importedCount }} ໂຮງຮຽນເຂົ້າລະບົບສຳເລັດແລ້ວ.</p>
        <b-button variant="primary" @click="closeImport">ປິດ</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";

const SCHOOL_FIELDS = ["school_id", "school_name_lao", "school_name_eng", "district_id", "prov_id", "emis_code", "School_lunch"];

export default {
  created() {
    let login = localStorage.getItem("Login");
    this.user = JSON.parse(login);
    this.loadTree();
  },
  data() {
    return {
      user: null,
      treeData: [],
      selectedNode: null,

      // Import state
      importStep: 1,
      excelFile: null,
      fileLoading: false,
      importRows: [],
      existingIds: new Set(),
      importing: false,
      importedCount: 0,

      previewFields: [
        { key: "_status", label: "ສະຖານະ", thStyle: { width: "120px" } },
        { key: "school_id", label: "ລະຫັດໂຮງຮຽນ" },
        { key: "school_name_lao", label: "ຊື່ໂຮງຮຽນ (ລາວ)" },
        { key: "school_name_eng", label: "ຊື່ໂຮງຮຽນ (ອັງກິດ)" },
        { key: "district_id", label: "ລະຫັດເມືອງ" },
        { key: "prov_id", label: "ລະຫັດແຂວງ" },
        { key: "emis_code", label: "EMIS Code" },
        { key: "School_lunch", label: "ອາຫານທ່ຽງ" },
      ],

      // ຂໍ້ມູນນັກຮຽນປະຈຳສົກຮຽນ
      statsAccd: "",
      statsRecordId: null,
      statsSaving: false,
      stats: {
        total_students: "",
        female_students: "",
        male_students: "",
        lunch_total: "",
        lunch_female: "",
        lunch_male: "",
      },
      accdOptions: (() => {
        const now = new Date();
        const curYear = (now.getMonth() + 1) >= 9 ? now.getFullYear() : now.getFullYear() - 1;
        const list = [];
        for (let i = 2; i >= -2; i--) {
          const y = curYear - i;
          list.push({ value: `${y}-${y + 1}`, text: `${y}-${y + 1}` });
        }
        return list;
      })(),
    };
  },
  computed: {
    newCount() {
      return this.importRows.filter(r => r._status === "new").length;
    },
    dupCount() {
      return this.importRows.filter(r => r._status === "dup").length;
    },
    errorCount() {
      return this.importRows.filter(r => r._status === "error").length;
    },
  },
  methods: {
    loadTree() {
      axios
        .get(`${this.$store.getters.getBaseUrl}/treeschools`, {
          headers: { Authorization: "Bearer " + this.user.login_hash },
        })
        .then(r => { this.treeData = r.data; })
        .catch(console.error);
    },
    nodeSelect(node, isSelected) {
      if (isSelected) {
        this.selectedNode = node.data;
      } else if (node.data === this.selectedNode) {
        this.selectedNode = null;
      }
      this.statsAccd = "";
      this.statsRecordId = null;
      this.stats = { total_students: "", female_students: "", male_students: "", lunch_total: "", lunch_female: "", lunch_male: "" };
    },

    // ---- ຂໍ້ມູນນັກຮຽນປະຈຳສົກຮຽນ ----
    async loadYearlyStats() {
      this.statsRecordId = null;
      this.stats = { total_students: "", female_students: "", male_students: "", lunch_total: "", lunch_female: "", lunch_male: "" };
      if (!this.statsAccd || !this.selectedNode) return;
      try {
        const res = await axios.get(
          `${this.$store.getters.getBaseUrl}/getRows/school_yearly_stats/school_id/${this.selectedNode.id}`,
          { headers: { Authorization: "Bearer " + this.user.login_hash } }
        );
        const rows = res.data || [];
        const found = rows.find(r => r.accd === this.statsAccd);
        if (found) {
          this.statsRecordId = found._id;
          this.stats = {
            total_students: found.total_students || "",
            female_students: found.female_students || "",
            male_students: found.male_students || "",
            lunch_total: found.lunch_total || "",
            lunch_female: found.lunch_female || "",
            lunch_male: found.lunch_male || "",
          };
        }
      } catch (e) {
        console.error(e);
      }
    },
    addNextAccd() {
      if (!this.statsAccd) return;
      const [y1, y2] = this.statsAccd.split('-').map(v => parseInt(v));
      const nextAccd = `${y1 + 1}-${y2 + 1}`;
      if (!this.accdOptions.find(o => o.value === nextAccd)) {
        this.accdOptions.push({ value: nextAccd, text: nextAccd });
        this.accdOptions.sort((a, b) => a.value.localeCompare(b.value));
      }
      this.statsAccd = nextAccd;
      this.loadYearlyStats();
    },
    async saveYearlyStats() {
      if (!this.statsAccd || !this.selectedNode) return;
      this.statsSaving = true;
      try {
        const payload = {
          school_id: this.selectedNode.id,
          accd: this.statsAccd,
          total_students: this.stats.total_students,
          female_students: this.stats.female_students,
          male_students: this.stats.male_students,
          lunch_total: this.stats.lunch_total,
          lunch_female: this.stats.lunch_female,
          lunch_male: this.stats.lunch_male,
        };
        const headers = { Authorization: "Bearer " + this.user.login_hash };
        let res;
        if (this.statsRecordId) {
          res = await axios.post(
            `${this.$store.getters.getBaseUrl}/jsonUpdate`,
            { table: "school_yearly_stats", wharevalue: this.statsRecordId, rows: payload },
            { headers }
          );
        } else {
          res = await axios.post(
            `${this.$store.getters.getBaseUrl}/insertOne`,
            { table: "school_yearly_stats", data: payload },
            { headers }
          );
          if (res.data && res.data.insertedId) this.statsRecordId = res.data.insertedId;
        }
        if (res.data && res.data.code === 1) {
          this.$bvToast.toast("ບັນທຶກຂໍ້ມູນນັກຮຽນສຳເລັດ", {
            title: "ສຳເລັດ",
            variant: "success",
            solid: true,
            toaster: "b-toaster-top-right",
          });
        } else {
          this.$bvToast.toast((res.data && res.data.desc) || "ບັນທຶກບໍ່ສຳເລັດ", {
            title: "Error",
            variant: "danger",
            solid: true,
            toaster: "b-toaster-top-right",
          });
        }
      } catch (e) {
        console.error(e);
        this.$bvToast.toast("ເກີດຂໍ້ຜິດພາດ: " + e.message, {
          title: "Error",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-right",
        });
      } finally {
        this.statsSaving = false;
      }
    },

    // ---- Import ----
    openImport() {
      this.resetImport();
      this.$refs["import-modal"].show();
    },
    resetImport() {
      this.importStep = 1;
      this.excelFile = null;
      this.importRows = [];
      this.importing = false;
      this.importedCount = 0;
      this.existingIds = new Set();
    },
    closeImport() {
      this.$refs["import-modal"].hide();
      this.loadTree();
    },

    async onFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.fileLoading = true;

      try {
        // 1. Fetch existing school IDs
        const res = await axios.get(
          `${this.$store.getters.getBaseUrl}/getItems/schools/school_name_lao/school_id`,
          { headers: { Authorization: "Bearer " + this.user.login_hash } }
        );
        this.existingIds = new Set((res.data || []).map(x => String(x.value).trim()));

        // 2. Parse Excel
        const buf = await file.arrayBuffer();
        const wb = XLSX.read(buf, { type: "array" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(ws, { defval: "" });

        // 3. Validate each row
        this.importRows = rows.map(row => {
          const normalized = {};
          SCHOOL_FIELDS.forEach(f => {
            normalized[f] = String(row[f] || row[this._laoKey(f)] || "").trim();
          });
          normalized.School_lunch = Number(normalized.School_lunch) || 0;

          let status = "new";
          if (!normalized.school_id || !normalized.school_name_lao || !normalized.district_id) {
            status = "error";
          } else if (this.existingIds.has(normalized.school_id)) {
            status = "dup";
          }
          return { ...normalized, _status: status };
        });

        this.importStep = 2;
      } catch (e) {
        console.error(e);
        this.$bvToast.toast("ອ່ານໄຟລ໌ບໍ່ສຳເລັດ: " + e.message, {
          title: "Error",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-right",
        });
      } finally {
        this.fileLoading = false;
      }
    },

    _laoKey(field) {
      const map = {
        school_id: "ລະຫັດໂຮງຮຽນ",
        school_name_lao: "ຊື່ໂຮງຮຽນ",
        school_name_eng: "School Name",
        district_id: "ລະຫັດເມືອງ",
        prov_id: "ລະຫັດແຂວງ",
        emis_code: "EMIS",
        School_lunch: "ອາຫານທ່ຽງ",
      };
      return map[field] || field;
    },

    async doImport() {
      const toInsert = this.importRows
        .filter(r => r._status === "new")
        .map(r => {
          const rest = { ...r };
          delete rest._status;
          return rest;
        });

      if (toInsert.length === 0) return;

      this.importing = true;
      try {
        const res = await axios.post(
          `${this.$store.getters.getBaseUrl}/insertMany`,
          { table: "schools", data: toInsert },
          { headers: { Authorization: "Bearer " + this.user.login_hash } }
        );

        if (res.data.code === 1) {
          this.importedCount = res.data.insertedCount || toInsert.length;
          this.importStep = 3;
        } else {
          this.$bvToast.toast(res.data.desc || "ນຳເຂົ້າບໍ່ສຳເລັດ", {
            title: "Error",
            variant: "danger",
            solid: true,
            toaster: "b-toaster-top-right",
          });
        }
      } catch (e) {
        console.error(e);
        this.$bvToast.toast("ເກີດຂໍ້ຜິດພາດ: " + e.message, {
          title: "Error",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-right",
        });
      } finally {
        this.importing = false;
      }
    },

    downloadTemplate() {
      const ws = XLSX.utils.aoa_to_sheet([
        ["school_id", "school_name_lao", "school_name_eng", "district_id", "prov_id", "emis_code", "School_lunch"],
        ["0101001", "ໂຮງຮຽນ ຕົວຢ່າງ", "Example School", "0101", "01", "LAO001", "1"],
      ]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "schools");
      XLSX.writeFile(wb, "school_import_template.xlsx");
    },

    statusLabel(s) {
      return s === "new" ? "ໃໝ່" : s === "dup" ? "ມີຢູ່ແລ້ວ" : "ຂໍ້ມູນບໍ່ຄົບ";
    },
    statusVariant(s) {
      return s === "new" ? "success" : s === "dup" ? "warning" : "danger";
    },
    statusIcon(s) {
      return s === "new" ? "plus-circle-fill" : s === "dup" ? "exclamation-triangle-fill" : "x-circle-fill";
    },
  },
};
</script>

<style scoped>
.font-size-sm {
  font-size: 0.85rem;
}
</style>
